
define('ldsh!modules/editor/templates/correodirect_forms_empty_view', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<p data-i18n="integration.webserviceFieldsEmpty"></p>\n';

}
return __p
};});

